import { getDomainFromUrl } from 'cw-ui-core';
import { call, put } from 'redux-saga/effects';
import { GET, getHeaders } from 'src/services/ApiService';
import { fetchProductsFailure, fetchProductsSuccess } from '../slice';

export const SoftwareCatalog = Object.freeze({
    '35d537be-b6a7-11e8-a7b7-0800273596d2': 'Automate',
    'c921c0e4-9b47-480a-bc84-82a1077c2c10': 'Control',
    '4e8117dd-6c2d-4385-a1c9-2b821e1aa14e': 'Manage',
    '814a1adf-ce6b-4a29-a391-032cb4f01323': 'Sell',
});

export const getInstanceName = (uri, softwareId) => {
    const hostname = uri ? getDomainFromUrl(uri, false) : '--';
    if (SoftwareCatalog[softwareId] === 'Manage') {
        const companyPattern = /(.*auth\/)(.*)(\/CentralLoginAcs.*)/;
        const company = uri ? uri.replace(companyPattern, '$2') : '--';
        return hostname === '--' ? hostname : `${hostname} | ${company}`;
    }
    return hostname;
};

export function* getProducts() {
    const result = yield call(GET, '/clients', getHeaders());
    if (result.isSuccess) {
        const instances = [];

        result.response.forEach(client => {
            const updatedClient = client;
            updatedClient.product = SoftwareCatalog[updatedClient.softwareId]
                ? SoftwareCatalog[updatedClient.softwareId]
                : '--';
            updatedClient.instanceName = getInstanceName(updatedClient.redirectUris[0], updatedClient.softwareId);
            instances.push(updatedClient);
        });
        yield put(
            fetchProductsSuccess({
                rows: result.response,
            })
        );
    } else {
        // const error = formatMessage(Locale.failedGetProducts);
        yield put(fetchProductsFailure(result));
    }
}
